// src/components/pages/ContactPage.tsx
import React from 'react';
// ↓↓↓ 実際のプロジェクト構造に合わせてパスを調整してください ↓↓↓
import {
  PageContainer,
  CommonPageTitle,
  ContentParagraph,
  EmphasisText,
  SubHeading, // 必要であればセクション分けに
} from '../styles/GlobalStyles'; // GlobalStylesから汎用スタイルをインポート
import styled from '@emotion/styled'; // このページ固有のスタイルのため

// お問い合わせボタン用のスタイル (Works.tsxのExternalLinkを参考に)
const ContactButton = styled.a`
  display: inline-block;
  margin-top: 20px;
  padding: 15px 30px;
  background-color: #00bcd4; // メインカラー
  color: #0d0d0d; //濃い背景色に合わせたテキスト色
  font-size: 1.1em;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #0097a7; // ホバー時の色
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 255, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 5px rgba(0, 255, 255, 0.3);
  }
`;

const ContactInfoWrapper = styled.div`
  margin-top: 30px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  text-align: center;
`;

const EmailAddress = styled.p`
  font-size: 1.2em;
  color: #f0f0f0;
  margin-bottom: 25px;

  a {
    color: #00e5ff; // 強調色
    text-decoration: none;
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ContactPage: React.FC = () => {
  const email = "main@ludyworks.com";
  const subject = "HPからの問い合わせ";
  const encodedSubject = encodeURIComponent(subject);
  const mailtoLink = `mailto:${email}?subject=${encodedSubject}`;

  return (
    <PageContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <CommonPageTitle>お問い合わせ</CommonPageTitle>
      <ContentParagraph style={{ textAlign: 'center' }}>
        LudyWorksのサービスや採用に関するご質問、その他お問い合わせは、
        <br />
        下記のメールアドレスまたはお問い合わせボタンよりお気軽にご連絡ください。
      </ContentParagraph>

      <ContactInfoWrapper>
        <SubHeading style={{ marginTop: 0, textAlign: 'center', borderBottom: 'none' }}>
          連絡先メールアドレス
        </SubHeading>
        <EmailAddress>
          <EmphasisText>Email:</EmphasisText> <a href={`mailto:${email}`}>{email}</a>
        </EmailAddress>

        <ContactButton href={mailtoLink}>
          メールでお問い合わせ
        </ContactButton>
        <ContentParagraph style={{ marginTop: '20px', fontSize: '0.9em', color: '#a0a0a0' }}>
          （メールソフトが起動します）
        </ContentParagraph>
      </ContactInfoWrapper>

      <ContentParagraph style={{ marginTop: '40px', textAlign: 'center', fontSize: '0.95em', color: '#c0c0c0' }}>
        お問い合わせ内容を確認後、担当者より通常3営業日以内にご返信させていただきます。
        <br />
        万が一返信がない場合は、お手数ですが再度ご連絡いただくか、メール設定をご確認ください。
      </ContentParagraph>
    </PageContainer>
  );
};

export default ContactPage;